import Menu from '@/global/components/MenuV2'
import { cpfValido } from '@acme/common'
import { Box, Grid } from '@mui/material'
import { FormField, FormFieldMask } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'

export function Documentos() {
    const { setError, clearErrors, getValues } = useFormContext()
    return (
        <Box component="section" id="documentos">
            <Grid container columns={24} spacing={1} columnSpacing={2}>
                <Grid item xs={24}>
                    <FormField required name="nome" label="Nome" />
                </Grid>
                <Grid item xs={6}>
                    <FormFieldMask
                        required
                        name="cpf"
                        label="CPF"
                        mask="999.999.999-99"
                        defaultValue={''}
                        inputProps={{
                            onBlur: () => {
                                const cpfValue = getValues('cpf')
                                if (!cpfValido(cpfValue)) {
                                    setError('cpf', { message: 'CPF inválido' })
                                } else {
                                    clearErrors('cpf')
                                }
                            },
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormFieldMask
                        required
                        name="pis"
                        label="PIS"
                        mask="999.99999.99-9"
                    />
                </Grid>
                <Grid item xs={5}>
                    <FormField name="sexo" label="Sexo" select defaultValue="M">
                        <Menu.Item value="M">Masc.</Menu.Item>
                        <Menu.Item value="F">Fem.</Menu.Item>
                    </FormField>
                </Grid>
                <Grid item xs={7}>
                    <FormField
                        name="dtNascimento"
                        InputLabelProps={{ shrink: true }}
                        label="Data de nascimento"
                        type="date"
                    />
                </Grid>
            </Grid>
        </Box>
    )
}
